// 1) Helper to load local storage item
export function getLocalState(key) {
  const state = localStorage.getItem(key);
  return state;
}

// 2) Helper to save local storage item
export function saveLocalState(key, state) {
  localStorage.setItem(key, state);
}